import classNames from "classnames";
import React from "react";
import { Image } from "~/components/ui/core/Image";
import { Link } from "~/components/ui/core/Link";
import {
  SIDEBAR_KEYBOARD_SHORTCUT,
  SidebarGroup,
  SidebarHeader,
  SidebarMenuButton,
  SidebarTrigger,
  useSidebar,
} from "~/components/ui/shadcn/ui/sidebar";
import { config } from "~/config";
import { useSession } from "~/hooks/useSession";
import { useI18n } from "~/lib/i18n/useI18n";
import { formatShortcut } from "~/lib/shadcn";

export const SidebarLogo: React.FC = () => {
  const { user } = useSession();
  const { fullOpen } = useSidebar();
  const { t } = useI18n();

  const logo = fullOpen ? (
    <Image width={120} height={60} src="/images/logo-dark.svg" alt="Figures logo" />
  ) : (
    <Image width={24} height={24} className="mt-1" src="/images/favicon.svg" alt="Figures logo" />
  );

  const shortcut = formatShortcut(SIDEBAR_KEYBOARD_SHORTCUT);

  return (
    <>
      <SidebarHeader
        className={classNames({
          "flex flex-row items-center justify-between": true,
          "mx-3": fullOpen,
          "ml-1": !fullOpen,
        })}
      >
        {user ? (
          <Link to={{ pathname: "/home" }} noLinkStyle>
            {logo}
          </Link>
        ) : (
          <a href={config.app.websiteUrl} target="_blank" rel="noopener noreferrer">
            {logo}
          </a>
        )}

        {fullOpen && <SidebarTrigger />}
      </SidebarHeader>

      {!fullOpen && (
        <SidebarGroup>
          <SidebarMenuButton asChild tooltip={`${t("components.layout.sidebar.toggle-sidebar")} (${shortcut})`}>
            <SidebarTrigger />
          </SidebarMenuButton>
        </SidebarGroup>
      )}
    </>
  );
};
